'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

export default function PublicTopbar() {
  const [mobileOpen, setMobileOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full h-16 border-b border-border glass-card">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 h-full flex items-center justify-between">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2.5">
          <AppLogo size={32} />
          <span className="font-bold text-lg gradient-primary-text tracking-tight hidden sm:block">GameForge</span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6">
          <Link href="/explore" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Explorar
          </Link>
          <Link href="/dashboard" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Dashboard
          </Link>
          <Link href="/create-game" className="text-sm font-medium text-muted-foreground hover:text-foreground transition-colors">
            Criar Jogo
          </Link>
        </nav>

        {/* Actions */}
        <div className="flex items-center gap-3">
          <Link
            href="/sign-up-login-screen"
            className="hidden md:flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all duration-150"
          >
            Entrar
          </Link>
          <Link
            href="/sign-up-login-screen"
            className="flex items-center gap-1.5 px-4 py-2 rounded-lg text-sm font-semibold text-white gradient-primary hover:opacity-90 active:scale-95 transition-all duration-150"
          >
            <Icon name="SparklesIcon" size={14} variant="solid" />
            Criar Grátis
          </Link>
          <button
            className="md:hidden p-2 rounded-lg hover:bg-muted/50 transition-colors"
            onClick={() => setMobileOpen(!mobileOpen)}
          >
            <Icon name="Bars3Icon" size={20} className="text-foreground" />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {mobileOpen && (
        <div className="md:hidden border-t border-border bg-card px-4 py-3 space-y-1 animate-slide-up">
          <Link href="/explore" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors">
            <Icon name="GlobeAltIcon" size={16} />
            Explorar
          </Link>
          <Link href="/dashboard" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors">
            <Icon name="HomeIcon" size={16} />
            Dashboard
          </Link>
          <Link href="/create-game" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors">
            <Icon name="SparklesIcon" size={16} />
            Criar Jogo
          </Link>
          <Link href="/sign-up-login-screen" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-sm text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors">
            <Icon name="UserCircleIcon" size={16} />
            Entrar / Registar
          </Link>
        </div>
      )}
    </header>
  );
}